import { UserRole } from "@/core/services/api/enums/UserRole";
import store from "@/store";
import { RouteLocationRaw } from "vue-router";
import { GuardedElement } from "@/core/config/MainMenuConfig";

export interface FooterMenuElement extends GuardedElement<FooterMenuElement> {
  heading: () => string;
  route: RouteLocationRaw;
  subTitle?: string;
  svgIcon?: string;
  fontIcon?: string;
  svgClass?: string;
}

export const FooterMenuElements: FooterMenuElement[] = [
  {
    heading: (): string => "Dashboard",
    route: {
      name: "admin.dashboard",
    },
    svgIcon: "/media/icons/duotune/general/gen001.svg",
    fontIcon: "bi-app-indicator",
    roles: [UserRole.ADMIN, UserRole.SUPER_ADMIN],
  },
  {
    heading: (): string => "My Profile",
    route: {
      name: "admin.profile",
    },
    svgIcon: "/media/icons/duotune/general/gen001.svg",
    fontIcon: "bi-app-indicator",
    roles: [UserRole.ADMIN, UserRole.SUPER_ADMIN],
  },
  {
    heading: (): string => "Dashboard",
    route: {
      name: "manager.dashboard",
    },
    svgIcon: "/media/icons/duotune/general/gen001.svg",
    fontIcon: "bi-app-indicator",
    roles: [UserRole.MANAGER, UserRole.MANAGER_READER],
    isAllowed: (): boolean =>
      !store.getters.isUserComplianceTrackingRequired &&
      store.getters.isUserCompanyEnabled &&
      store.getters.isIndividualOrHas2FA,
  },
  {
    heading: (): string => "Support",
    roles: [UserRole.MANAGER, UserRole.MANAGER_READER],
    svgIcon: "/media/icons/duotune/communication/com003.svg",
    route: {
      name: "manager.support.tickets.list",
    },
    isAllowed: (): boolean =>
      store.getters.isUserCompanyEnabled && store.getters.isIndividualOrHas2FA,
  },
  {
    heading: (): string => "My Profile",
    roles: [UserRole.MANAGER, UserRole.MANAGER_READER],
    svgIcon: "/media/icons/duotune/communication/com003.svg",
    route: {
      name: "manager.profile",
    },
    isAllowed: (): boolean =>
      store.getters.isUserAuthenticated &&
      !store.getters.isUserComplianceTrackingRequired,
  },
];
